import { createSlice } from '@reduxjs/toolkit';
import { GetBranding, GetLogoImage } from '../../api/themesCalls';
import { arrayBufferToBase64 } from '../../Member/utils/common';
import HttpHeader from '../../Member/shared/httpheader';

const Keenan_var = {
  Copyright: `Copyright © ${new Date().getFullYear()} Keenan & Associates • CA Insurance License Number. 0451271`,
  ClientName: 'Keenan',
};

const Demo_var = {
  Copyright: 'Copyright 2024 A1M Health Insurance',
  ClientName: 'Demo',
};

const QA_var = {
  Copyright: 'Copyright 2024 A1M Health Insurance',
  ClientName: 'QA',
};

export const themeSlice = createSlice({
  name: 'theme',
  initialState: {
    isThemeLoaded: false,
    branding: {},
    isLogoLoaded: false,
    logoImage: null,
    logoType: null,
    error: null,
  },
  reducers: {
    setTheme: (state) => {
      state.isThemeLoaded = true;
    },
  },
  extraReducers: {
    [GetBranding.pending]: (state, action) => {
      state.isThemeLoaded = false;
    },
    [GetBranding.fulfilled]: (state, action) => {
      const themeValuesObject = {};
      state.isThemeLoaded = true;
      state.branding = action.payload.data.Response.Branding || {};
      const cName = HttpHeader.getCNAME();
      if (cName.includes('keenan') || cName.includes('tpabenefits')) {
        state.branding = {
          ...action.payload.data.Response.Branding,
          ...Keenan_var,
        };
      }
      if (cName === 'a1m-qa') {
        state.branding = {
          ...action.payload.data.Response.Branding,
          ...QA_var,
        };
      }
      if (cName === 'a1m-demo') {
        state.branding = {
          ...action.payload.data.Response.Branding,
          ...Demo_var,
        };
      }

      action.payload.data.Response.Branding.ThemeValues.forEach((ele) => {
        themeValuesObject[ele.BrandingKey] = ele.BrandingValue;
      });
      state.themeValuesObject = themeValuesObject;
    },
    [GetBranding.rejected]: (state, action) => {
      state.isThemeLoaded = false;
      state.branding = null;
    },
    [GetLogoImage.pending]: (state, action) => {
      state.isLogoLoaded = false;
    },
    [GetLogoImage.fulfilled]: (state, action) => {
      state.isLogoLoaded = true;
      const imgType = action.payload.headers['content-type'];
      state.logoType = imgType;
      state.logoImage = arrayBufferToBase64(action.payload.data);
    },
    [GetLogoImage.rejected]: (state, action) => {
      state.isLogoLoaded = false;
      state.logoImage = null;
    },
  },
});

//Action creators are generated for each case reducer function
export const { setTheme } = themeSlice.actions;

export default themeSlice.reducer;
